import OnDemandRouteAvatarGroup from './OnDemandRouteAvatarGroup';

type Props = {
  crewMemberIds?: string | null
  crewLeadId?: number | null
}

const OnDemandRouteAvatar = ({ crewMemberIds, crewLeadId }: Props) => {
  return <OnDemandRouteAvatarGroup crewMemberIds={crewMemberIds} crewLeadId={crewLeadId} />
}

export default OnDemandRouteAvatar